// GENERATED FILE, PLEASE DO NOT EDIT
export var SystemGrey0 = '#f7f7f7';
export var SystemGrey5 = '#e7e7e7';
export var SystemGrey10 = '#d6d6d6';
export var SystemGrey20 = '#c4c4c4';
export var SystemGrey30 = '#b2b2b2';
export var SystemGrey40 = '#9f9f9f';
export var SystemGrey50 = '#8b8b8b';
export var SystemGrey60 = '#767676';
export var SystemGrey70 = '#606060';
export var SystemGrey80 = '#494949';
export var SystemGrey90 = '#313131';
export var SystemGrey95 = '#242424';
export var SystemGrey100 = '#191919';
export var SystemRed0 = '#fff7f5';
export var SystemRed5 = '#fff0ed';
export var SystemRed10 = '#ffe0db';
export var SystemRed20 = '#fec7bd';
export var SystemRed30 = '#fda294';
export var SystemRed40 = '#fa7463';
export var SystemRed50 = '#f54323';
export var SystemRed60 = '#eb1700';
export var SystemRed70 = '#d91400';
export var SystemRed80 = '#b71000';
export var SystemRed90 = '#810b00';
export var SystemRed100 = '#380500';
export var SystemYellow0 = '#ffffeb';
export var SystemYellow5 = '#ffffa3';
export var SystemYellow10 = '#feff58';
export var SystemYellow20 = '#f6e61b';
export var SystemYellow30 = '#e8c500';
export var SystemYellow40 = '#d5a600';
export var SystemYellow50 = '#bd8800';
export var SystemYellow60 = '#a16c00';
export var SystemYellow70 = '#835200';
export var SystemYellow80 = '#835200';
export var SystemYellow90 = '#452700';
export var SystemYellow100 = '#261500';
export var SystemGreen0 = '#f6fffa';
export var SystemGreen5 = '#e7fbef';
export var SystemGreen10 = '#cef4dd';
export var SystemGreen20 = '#a9e9c1';
export var SystemGreen30 = '#7bd89d';
export var SystemGreen40 = '#4bc275';
export var SystemGreen50 = '#1fa74f';
export var SystemGreen60 = '#00872f';
export var SystemGreen70 = '#006a25';
export var SystemGreen80 = '#004c1b';
export var SystemGreen90 = '#002f10';
export var SystemGreen100 = '#001206';
export var SystemTeal0 = '#f5ffff';
export var SystemTeal5 = '#ecfcfc';
export var SystemTeal10 = '#d7f5f5';
export var SystemTeal20 = '#b6e9ea';
export var SystemTeal30 = '#8bd8da';
export var SystemTeal40 = '#5bc1c4';
export var SystemTeal50 = '#2aa4a9';
export var SystemTeal60 = '#00838a';
export var SystemTeal70 = '#00666d';
export var SystemTeal80 = '#00494e';
export var SystemTeal90 = '#002c2f';
export var SystemTeal100 = '#001012';
export var SystemBlue0 = '#fafbff';
export var SystemBlue5 = '#f4f6fe';
export var SystemBlue10 = '#e6ebfd';
export var SystemBlue20 = '#d1dafb';
export var SystemBlue30 = '#b4c2fa';
export var SystemBlue40 = '#91a5f9';
export var SystemBlue50 = '#6c87fb';
export var SystemBlue60 = '#4969f5';
export var SystemBlue70 = '#2a4de4';
export var SystemBlue80 = '#1537c7';
export var SystemBlue90 = '#082496';
export var SystemBlue100 = '#02124f';
export var SystemWhite = '#ffffff';
export var SystemBlack = '#191919';
export var BackgroundPrimary = SystemWhite;
export var BackgroundPrimaryInverted = SystemBlack;
export var BackgroundSecondary = SystemGrey0;
export var BackgroundSecondaryInverted = SystemGrey90;
export var BackgroundTertiary = SystemGrey5;
export var BackgroundElevated = SystemWhite;
export var BackgroundOverlay = SystemBlack;
export var BannerDefaultBackground = SystemGrey0;
export var BannerDefaultForeground = SystemBlack;
export var BannerDefaultIcon = SystemBlack;
export var BannerHighlightBackground = SystemTeal5;
export var BannerHighlightForeground = SystemBlack;
export var BannerHighlightIcon = SystemTeal70;
export var BannerInformationalBackground = SystemGrey80;
export var BannerInformationalForeground = SystemWhite;
export var BannerInformationalIcon = SystemWhite;
export var BannerNegativeBackground = SystemRed5;
export var BannerNegativeForeground = SystemBlack;
export var BannerNegativeIcon = SystemRed80;
export var BannerPositiveBackground = SystemGreen5;
export var BannerPositiveForeground = SystemBlack;
export var BannerPositiveIcon = SystemGreen60;
export var BannerWarningBackground = SystemYellow5;
export var BannerWarningForeground = SystemBlack;
export var BannerWarningIcon = SystemYellow40;
export var BorderPrimary = SystemGrey5;
export var BorderSecondary = SystemGrey10;
export var BrandRedBase = '#ff3008';
export var BrandRedDark = '#de3725';
export var BrandSkyLight = '#e1f6fa';
export var BrandSkyBase = '#d1f0f6';
export var BrandSkyDark = '#bedfe9';
export var BrandSkyText = '#24809c';
export var BrandLemonLight = '#fcf89a';
export var BrandLemonBase = '#faf258';
export var BrandLemonDark = '#f8e500';
export var BrandOceanLight = '#73a3a6';
export var BrandOceanBase = '#518c8f';
export var BrandOceanDark = '#3a646e';
export var BrandOceanText = '#00838a';
export var BrandFlushLight = '#fae4e1';
export var BrandFlushBase = '#f3d1cd';
export var BrandFlushDark = '#e5bbb7';
export var BrandFlushText = '#ce483b';
export var BrandForestLight = '#61786d';
export var BrandForestBase = '#3a5648';
export var BrandForestDark = '#28362c';
export var BrandStoneLight = '#e6e5d8';
export var BrandStoneBase = '#c6c5b6';
export var BrandStoneDark = '#666666';
export var ButtonDefaultForeground = SystemWhite;
export var ButtonDefaultForegroundDisabled = SystemWhite;
export var ButtonDefaultForegroundHovered = SystemWhite;
export var ButtonDefaultForegroundPressed = SystemWhite;
export var ButtonDefaultToggleForeground = SystemWhite;
export var ButtonDefaultToggleForegroundDisabled = SystemGrey20;
export var ButtonDefaultToggleForegroundHovered = SystemWhite;
export var ButtonDefaultToggleForegroundOff = SystemBlack;
export var ButtonDefaultToggleForegroundOffDisabled = SystemGrey50;
export var ButtonDefaultToggleForegroundOffHovered = SystemBlack;
export var ButtonDefaultToggleForegroundOffPressed = SystemBlack;
export var ButtonDefaultToggleForegroundPressed = SystemWhite;
export var ButtonFabBackground = SystemWhite;
export var ButtonFabBackgroundDisabled = SystemGrey0;
export var ButtonFabBackgroundHovered = SystemGrey0;
export var ButtonFabBackgroundPressed = SystemGrey5;
export var ButtonFabForeground = SystemBlack;
export var ButtonFabForegroundDisabled = SystemGrey30;
export var ButtonFabForegroundHovered = SystemBlack;
export var ButtonFabForegroundPressed = SystemBlack;
export var ButtonFlatPrimaryForeground = SystemRed60;
export var ButtonFlatPrimaryForegroundDisabled = SystemGrey30;
export var ButtonFlatPrimaryForegroundHovered = SystemRed70;
export var ButtonFlatPrimaryForegroundPressed = SystemRed80;
export var ButtonFlatSecondaryForeground = SystemBlack;
export var ButtonFlatSecondaryForegroundDisabled = SystemGrey30;
export var ButtonFlatSecondaryForegroundHovered = SystemGrey80;
export var ButtonFlatSecondaryForegroundPressed = SystemGrey90;
export var ButtonPlainBackground = SystemWhite;
export var ButtonPlainBackgroundDisabled = SystemWhite;
export var ButtonPlainBackgroundHovered = SystemGrey0;
export var ButtonPlainBackgroundPressed = SystemGrey5;
export var ButtonPlainForeground = SystemGrey80;
export var ButtonPlainForegroundDisabled = SystemGrey60;
export var ButtonPlainForegroundHovered = SystemGrey80;
export var ButtonPlainForegroundPressed = SystemGrey5;
export var ButtonPlainToggleBackground = SystemWhite;
export var ButtonPlainToggleBackgroundDisabled = SystemWhite;
export var ButtonPlainToggleBackgroundHovered = SystemGrey0;
export var ButtonPlainToggleBackgroundOff = SystemWhite;
export var ButtonPlainToggleBackgroundOffDisabled = SystemWhite;
export var ButtonPlainToggleBackgroundOffHovered = SystemGrey0;
export var ButtonPlainToggleBackgroundOffPressed = SystemGrey5;
export var ButtonPlainToggleBackgroundPressed = SystemGrey5;
export var ButtonPlainToggleForeground = SystemGrey80;
export var ButtonPlainToggleForegroundDisabled = SystemGrey60;
export var ButtonPlainToggleForegroundHovered = SystemGrey80;
export var ButtonPlainToggleForegroundOff = SystemGrey80;
export var ButtonPlainToggleForegroundOffDisabled = SystemGrey60;
export var ButtonPlainToggleForegroundOffHovered = SystemGrey80;
export var ButtonPlainToggleForegroundOffPressed = SystemGrey5;
export var ButtonPlainToggleForegroundPressed = SystemGrey5;
export var ButtonPrimaryBackground = SystemRed60;
export var ButtonPrimaryBackgroundDisabled = SystemGrey0;
export var ButtonPrimaryBackgroundHovered = SystemRed70;
export var ButtonPrimaryBackgroundPressed = SystemRed80;
export var ButtonPrimaryForeground = SystemWhite;
export var ButtonPrimaryForegroundDisabled = SystemGrey30;
export var ButtonPrimaryForegroundHovered = SystemWhite;
export var ButtonPrimaryForegroundPressed = SystemWhite;
export var ButtonPrimaryToggleBackground = SystemBlack;
export var ButtonPrimaryToggleBackgroundDisabled = SystemGrey10;
export var ButtonPrimaryToggleBackgroundHovered = SystemGrey70;
export var ButtonPrimaryToggleBackgroundOff = SystemGrey5;
export var ButtonPrimaryToggleBackgroundOffDisabled = SystemGrey0;
export var ButtonPrimaryToggleBackgroundOffHovered = SystemGrey0;
export var ButtonPrimaryToggleBackgroundOffPressed = SystemGrey10;
export var ButtonPrimaryToggleBackgroundPressed = SystemGrey80;
export var ButtonPrimaryToggleBorderOff = SystemGrey5;
export var ButtonPrimaryToggleBorderOffHovered = SystemGrey0;
export var ButtonPrimaryToggleBorderOffPressed = SystemGrey10;
export var ButtonPrimaryToggleBorderOffDisabled = SystemGrey0;
export var ButtonPrimaryToggleBorderOn = SystemBlack;
export var ButtonPrimaryToggleBorderOnHovered = SystemGrey70;
export var ButtonPrimaryToggleBorderOnPressed = SystemGrey80;
export var ButtonPrimaryToggleBorderOnDisabled = SystemGrey10;
export var ButtonPrimaryToggleForeground = SystemWhite;
export var ButtonPrimaryToggleForegroundDisabled = SystemGrey40;
export var ButtonPrimaryToggleForegroundHovered = SystemWhite;
export var ButtonPrimaryToggleForegroundOff = SystemBlack;
export var ButtonPrimaryToggleForegroundOffDisabled = SystemGrey30;
export var ButtonPrimaryToggleForegroundOffHovered = SystemBlack;
export var ButtonPrimaryToggleForegroundOffPressed = SystemBlack;
export var ButtonPrimaryToggleForegroundPressed = SystemWhite;
export var ButtonSecondaryBackground = SystemRed5;
export var ButtonSecondaryBackgroundDisabled = SystemGrey0;
export var ButtonSecondaryBackgroundHovered = SystemRed10;
export var ButtonSecondaryBackgroundPressed = SystemRed20;
export var ButtonSecondaryForeground = SystemRed70;
export var ButtonSecondaryForegroundDisabled = SystemGrey30;
export var ButtonSecondaryForegroundHovered = SystemRed70;
export var ButtonSecondaryForegroundPressed = SystemRed70;
export var ButtonSecondaryToggleBackground = SystemBlack;
export var ButtonSecondaryToggleBackgroundDisabled = SystemGrey10;
export var ButtonSecondaryToggleBackgroundHovered = SystemGrey70;
export var ButtonSecondaryToggleBackgroundPressed = SystemGrey80;
export var ButtonSecondaryToggleBackgroundOff = SystemGrey5;
export var ButtonSecondaryToggleBackgroundOffDisabled = SystemGrey0;
export var ButtonSecondaryToggleBackgroundOffHovered = SystemGrey0;
export var ButtonSecondaryToggleBackgroundOffPressed = SystemGrey10;
export var ButtonSecondaryToggleBorderOff = SystemGrey5;
export var ButtonSecondaryToggleBorderOffHovered = SystemGrey0;
export var ButtonSecondaryToggleBorderOffPressed = SystemGrey10;
export var ButtonSecondaryToggleBorderOffDisabled = SystemGrey0;
export var ButtonSecondaryToggleBorderOn = SystemBlack;
export var ButtonSecondaryToggleBorderOnHovered = SystemGrey70;
export var ButtonSecondaryToggleBorderOnPressed = SystemGrey80;
export var ButtonSecondaryToggleBorderOnDisabled = SystemGrey10;
export var ButtonSecondaryToggleForeground = SystemWhite;
export var ButtonSecondaryToggleForegroundDisabled = SystemGrey40;
export var ButtonSecondaryToggleForegroundHovered = SystemWhite;
export var ButtonSecondaryToggleForegroundPressed = SystemWhite;
export var ButtonSecondaryToggleForegroundOff = SystemBlack;
export var ButtonSecondaryToggleForegroundOffDisabled = SystemGrey30;
export var ButtonSecondaryToggleForegroundOffHovered = SystemBlack;
export var ButtonSecondaryToggleForegroundOffPressed = SystemBlack;
export var ButtonTertiaryBackground = SystemGrey5;
export var ButtonTertiaryBackgroundDisabled = SystemGrey0;
export var ButtonTertiaryBackgroundHovered = SystemGrey10;
export var ButtonTertiaryBackgroundPressed = SystemGrey20;
export var ButtonTertiaryForeground = SystemBlack;
export var ButtonTertiaryForegroundDisabled = SystemGrey30;
export var ButtonTertiaryForegroundHovered = SystemBlack;
export var ButtonTertiaryForegroundPressed = SystemBlack;
export var ButtonTertiaryToggleBackground = SystemBlack;
export var ButtonTertiaryToggleBackgroundDisabled = SystemGrey10;
export var ButtonTertiaryToggleBackgroundHovered = SystemGrey70;
export var ButtonTertiaryToggleBackgroundOff = SystemWhite;
export var ButtonTertiaryToggleBackgroundOffDisabled = SystemGrey0;
export var ButtonTertiaryToggleBackgroundOffHovered = SystemGrey10;
export var ButtonTertiaryToggleBackgroundOffPressed = SystemGrey5;
export var ButtonTertiaryToggleBackgroundPressed = SystemGrey80;
export var ButtonTertiaryToggleBorderOff = SystemBlack;
export var ButtonTertiaryToggleBorderOffHovered = SystemGrey70;
export var ButtonTertiaryToggleBorderOffPressed = SystemGrey80;
export var ButtonTertiaryToggleBorderOffDisabled = SystemGrey0;
export var ButtonTertiaryToggleBorderOn = SystemBlack;
export var ButtonTertiaryToggleBorderOnHovered = SystemGrey70;
export var ButtonTertiaryToggleBorderOnPressed = SystemGrey80;
export var ButtonTertiaryToggleBorderOnDisabled = SystemGrey10;
export var ButtonTertiaryToggleForeground = SystemWhite;
export var ButtonTertiaryToggleForegroundDisabled = SystemGrey40;
export var ButtonTertiaryToggleForegroundHovered = SystemWhite;
export var ButtonTertiaryToggleForegroundPressed = SystemWhite;
export var ButtonTertiaryToggleForegroundOff = SystemBlack;
export var ButtonTertiaryToggleForegroundOffDisabled = SystemGrey30;
export var ButtonTertiaryToggleForegroundOffHovered = SystemBlack;
export var ButtonTertiaryToggleForegroundOffPressed = SystemBlack;
export var DiagonalDefaultOverlay = SystemWhite;
export var FieldsIconDropdown = SystemBlack;
export var FieldsIconSearch = SystemBlack;
export var FieldsInputBackground = SystemWhite;
export var FieldsInputBackgroundDisabled = SystemGrey0;
export var FieldsInputBorder = SystemGrey10;
export var FieldsInputBorderError = SystemRed80;
export var ListCellContainerBackgroundDefault = SystemWhite;
export var ListCellContainerBackgroundHovered = SystemGrey0;
export var ListCellContainerBackgroundPressed = SystemGrey5;
export var ListCellContainerBackgroundUnread = SystemBlue5;
export var ListCellContainerBackgroundUnreadHovered = SystemBlue20;
export var ListCellContainerBackgroundUnreadPressed = SystemBlue10;
export var ListCellIconToggledOn = SystemRed60;
export var ListCellIconToggledOff = SystemGrey80;
export var LoadingDefault = SystemRed60;
export var ModalBackground = SystemWhite;
export var OverlayBackgroundDefault = SystemBlack;
export var OverlayBackgroundLoading = SystemWhite;
export var OverlayLoadingDefault = SystemRed60;
export var PageBackgroundPrimary = SystemWhite;
export var PageBackgroundSecondary = SystemGrey0;
export var PageBackgroundTertiary = SystemGrey5;
export var PaginationSelectedDark = SystemGrey60;
export var PaginationSelectedPrimary = SystemRed60;
export var PaginationSelectedLight = SystemWhite;
export var PaginationUnselectedDark = SystemGrey10;
export var PaginationUnselectedPrimary = SystemGrey10;
export var PaginationUnselectedLight = SystemGrey50;
export var PopoverContainerBackground = SystemWhite;
export var RatingSelected = SystemYellow30;
export var RatingUnselected = SystemGrey5;
export var RatingSelectedDisabled = SystemGrey30;
export var RatingUnselectedDisabled = SystemGrey0;
export var SliderKnobBackground = SystemBlack;
export var SliderKnobBackgroundHovered = SystemGrey80;
export var SliderKnobBackgroundPressed = SystemGrey90;
export var SliderKnobBackgroundDisabled = SystemGrey10;
export var SliderTrackBackgroundOff = SystemGrey5;
export var SliderTrackBackgroundOffDisabled = SystemGrey0;
export var SliderTrackBackgroundOn = SystemBlack;
export var SliderTrackBackgroundOnDisabled = SystemGrey10;
export var TagDefaultBackground = SystemGrey5;
export var TagDefaultForeground = SystemBlack;
export var TagDefaultIcon = SystemBlack;
export var TagHighlightBackground = SystemTeal60;
export var TagHighlightForeground = SystemWhite;
export var TagHighlightIcon = SystemWhite;
export var TagInformationalBackground = SystemGrey80;
export var TagInformationalForeground = SystemWhite;
export var TagInformationalIcon = SystemWhite;
export var TagNegativeBackground = SystemRed80;
export var TagNegativeForeground = SystemWhite;
export var TagNegativeIcon = SystemWhite;
export var TagPositiveBackground = SystemGreen5;
export var TagPositiveForeground = SystemGreen70;
export var TagPositiveIcon = SystemGreen70;
export var TagWarningBackground = SystemYellow20;
export var TagWarningForeground = SystemBlack;
export var TagWarningIcon = SystemBlack;
export var TextAction = SystemRed60;
export var TextCallout = SystemRed60;
export var TextDisabled = SystemGrey30;
export var TextError = SystemRed80;
export var TextHighlight = SystemTeal60;
export var TextLink = SystemTeal60;
export var TextPositive = SystemGreen60;
export var TextPrimary = SystemBlack;
export var TextPrimaryOnDark = SystemWhite;
export var TextSecondary = SystemGrey80;
export var TextSecondaryOnDark = SystemGrey10;
export var TextSelected = SystemRed60;
export var TextTertiary = SystemGrey60;
export var TextTooltip = SystemGrey20;
export var TextWarning = SystemYellow60;
export var TimelineTrackBackgroundOff = SystemGrey5;
export var TimelineTrackBackgroundOn = SystemBlack;
export var TimelineTrackForegroundOff = SystemBlack;
export var TimelineTrackForegroundOn = SystemWhite;
export var TimelineTrackShimmer = SystemGrey80;
export var ToastInformationalBackground = SystemGrey90;
export var ToastInformationalForeground = SystemGrey5;
export var ToastInformationalAction = SystemWhite;
export var ToastInformationalActionPressed = SystemGrey30;
export var ToastInformationalActionHovered = SystemGrey10;
export var ToastInformationalActionDisabled = SystemGrey70;
export var ToggleBackgroundOn = SystemBlack;
export var ToggleBackgroundOnDisabled = SystemGrey10;
export var ToggleBackgroundOff = SystemWhite;
export var ToggleBackgroundOffDisabled = SystemGrey0;
export var ToggleBorderOn = SystemBlack;
export var ToggleBorderOnDisabled = SystemGrey10;
export var ToggleBorderOff = SystemBlack;
export var ToggleBorderOffDisabled = SystemGrey30;
export var ToggleForegroundOn = SystemWhite;
export var ToggleForegroundOff = SystemWhite;
export var ToggleForegroundOnDisabled = SystemGrey0;
export var ToggleForegroundOffDisabled = SystemWhite;
export var ToggleBackgroundDisabled = SystemGrey10;
export var ToggleCheckmarkOn = SystemWhite;
export var ToggleTrackBackgroundDisabled = SystemGrey0;
export var ToggleTrackBackgroundOff = SystemGrey5;
export var TooltipHighlightBackground = SystemTeal60;
export var TooltipHighlightBackgroundHovered = SystemTeal70;
export var TooltipHighlightBackgroundPressed = SystemTeal80;
export var TooltipHighlightForeground = SystemWhite;
export var TooltipHighlightForegroundHovered = SystemWhite;
export var TooltipHighlightForegroundPressed = SystemWhite;
export var TooltipInformationalBackground = SystemGrey90;
export var TooltipInformationalBackgroundHovered = SystemGrey80;
export var TooltipInformationalBackgroundPressed = SystemGrey70;
export var TooltipInformationalForeground = SystemGrey20;
export var TooltipInformationalForegroundHovered = SystemGrey10;
export var TooltipInformationalForegroundPressed = SystemGrey5;
export var WarningForeground = SystemBlack;
export var WarningBackground = SystemYellow10;